export default __webpack_public_path__ + "static/media/DevFolio.ade4659c.PNG";